import React from 'react';
import Modal from 'components/UI/Modal';
import { connect } from 'react-redux';
import { alert } from 'util/alert';
import "./Modal.scss";
import ModalContent from "./ModalContent";
import { confirmable } from 'react-confirm';

// const mapStateToProps = (state) => ({
//   attendanceDetail: state.lessonAttendanceDetail,
//   classDetail: state.classLessonDetail
// })

class ModalBody extends React.Component {

  constructor(props){
    super(props)
  }

	render() {
		let {
      show,
      proceed,
      dismiss,
      cancel
    } = this.props;

		return (
      <Modal
				className='salary-modal'
				hasHeader={true}
        hasFooter={true}
				headerTitle={__("Salary Calculation", "teacherAttendance")}
				headerIcon="fa icon-calc"
        fixedWidth={550}
        contentHeight={570}
        onCloseModalClick={()=> proceed() }
        footerType="grey"
        footerButtons={[
          {
            title: __('Complete', 'appwrapper'),
            className: 'btn btn-primary pull-right',
            onClick: () => {
              proceed({data: this.formData});
            }
          }
        ]}
        isShowingModal={show} >
        <ModalContent
          fetching={false}
          {...this.props}
          onFormChange={(stateFromModalContent) => { this.formData = stateFromModalContent }} />
			</Modal>
    );
  }
}

export default connect()(confirmable(ModalBody));



// WEBPACK FOOTER //
// ./src/template/Modals/Salary/ModalBody.js